import { adminApi } from '@core/api/httpClient'
import type { MarketDto, CreateMarketPayload } from './marketContracts'

const BASE = '/api/admin/masters/markets'

export async function getMarkets(): Promise<MarketDto[]> {
  const { data } = await adminApi.get<{ data?: MarketDto[] } | MarketDto[]>(BASE)
  if (Array.isArray(data)) return data
  return (data as { data?: MarketDto[] }).data ?? []
}

export async function createMarket(payload: CreateMarketPayload): Promise<void> {
  await adminApi.post(BASE, payload)
}

export async function updateMarket(
  id: string,
  payload: Partial<CreateMarketPayload>,
): Promise<void> {
  await adminApi.patch(`${BASE}/${id}`, payload)
}

export async function deleteMarket(id: string): Promise<void> {
  await adminApi.delete(`${BASE}/${id}`)
}
